import { reactive } from "vue";

export const searchStore = reactive({
    searchTerm: ""
});
